import { Users, Truck, FileText, AlertTriangle } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface KPICardsProps {
  totalCustomers: number;
  totalSuppliers: number;
  totalAccounts: number;
  missingBillsCount: number;
  isLoading?: boolean;
}

export function KPICards({
  totalCustomers,
  totalSuppliers,
  totalAccounts,
  missingBillsCount,
  isLoading
}: KPICardsProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} className="p-6">
            <Skeleton className="h-8 w-8 mb-3" />
            <Skeleton className="h-4 w-20 mb-2" />
            <Skeleton className="h-8 w-16" />
          </Card>
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: 'Customers',
      value: totalCustomers,
      icon: Users,
      color: 'text-primary'
    },
    {
      title: 'Suppliers',
      value: totalSuppliers,
      icon: Truck,
      color: 'text-primary'
    },
    {
      title: 'Accounts',
      value: totalAccounts,
      icon: FileText,
      color: 'text-primary'
    },
    {
      title: 'Missing Bills',
      value: missingBillsCount,
      icon: AlertTriangle,
      color: 'text-destructive'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <Card key={card.title} className="p-6 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between">
              <div className="space-y-2">
                <p className="text-sm text-muted-foreground">{card.title}</p>
                <p className="text-3xl font-bold">{card.value.toLocaleString()}</p>
              </div>
              <Icon className={`h-8 w-8 ${card.color}`} />
            </div>
          </Card>
        );
      })}
    </div>
  );
}
